'use client';

const defaultProps = {
  orientation: "horizontal",
  size: "md"
};
export {
  defaultProps
};
